import { Box, NumberInput } from "@mantine/core";
import { useTranslation } from "@hooks/useTranslation";
import "./ConfigOptionsFields.scss";

interface ConfigOptionsFieldsProps {
    temperature: number | string;
    topP: number | string;
    topK: number | string;
    maxOutputTokens: number | string;
    thinkingBudget: number | string;
    seed: number | string;
    onTemperatureChange: (value: number | string) => void;
    onTopPChange: (value: number | string) => void;
    onTopKChange: (value: number | string) => void;
    onMaxOutputTokensChange: (value: number | string) => void;
    onThinkingBudgetChange: (value: number | string) => void;
    onSeedChange: (value: number | string) => void;
}

export const ConfigOptionsFields = ({
    temperature,
    topP,
    topK,
    maxOutputTokens,
    thinkingBudget,
    seed,
    onTemperatureChange,
    onTopPChange,
    onTopKChange,
    onMaxOutputTokensChange,
    onThinkingBudgetChange,
    onSeedChange,
}: ConfigOptionsFieldsProps) => {
    const { t } = useTranslation();

    return (
        <Box className="config-options-grid">
            <NumberInput
                label={t("admin.flowConfigs.labels.temperature")}
                value={temperature}
                onChange={onTemperatureChange}
                min={0}
                max={2}
                step={0.1}
                decimalScale={2}
                placeholder="e.g. 0.7"
            />
            <NumberInput
                label={t("admin.flowConfigs.labels.topP")}
                value={topP}
                onChange={onTopPChange}
                min={0}
                max={1}
                step={0.05}
                decimalScale={2}
                placeholder="e.g. 0.9"
            />
            <NumberInput
                label={t("admin.flowConfigs.labels.topK")}
                value={topK}
                onChange={onTopKChange}
                min={0}
                placeholder="e.g. 40"
            />
            <NumberInput
                label={t("admin.flowConfigs.labels.maxOutputTokens")}
                value={maxOutputTokens}
                onChange={onMaxOutputTokensChange}
                min={0}
                placeholder="e.g. 4096"
            />
            <NumberInput
                label={t("admin.flowConfigs.labels.thinkingBudget")}
                value={thinkingBudget}
                onChange={onThinkingBudgetChange}
                min={0}
                placeholder="e.g. 8192"
            />
            <NumberInput
                label={t("admin.flowConfigs.labels.seed")}
                value={seed}
                onChange={onSeedChange}
                min={0}
                placeholder="e.g. 42"
            />
        </Box>
    );
};
